import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStore } from '@application/auth.store';

@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrl: './login-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginViewComponent {
  private router = inject(Router);
  private auth = inject(AuthStore);
  private redirectedToChat = false;
  private submitting = signal(false);

  readonly loading = computed(() => this.auth.initializing() || this.submitting());
  readonly authError = computed(() => this.auth.authError());
  readonly msalConfigured = this.auth.hasMsalConfig();

  constructor() {
    effect(() => {
      if (!this.auth.ready() || !this.auth.isAuthenticated() || this.redirectedToChat) return;

      this.redirectedToChat = true;
      this.navigateToChat();
    });
  }

  async onLogin(): Promise<void> {
    if (this.loading()) return;

    this.submitting.set(true);
    const redirected = await this.auth.login();
    if (!redirected) this.submitting.set(false);
  }

  private navigateToChat(): void {
    this.router.navigate(['/chat']).catch(error => {
      console.error('Unable to navigate to chat after login', error);
    });
  }
}
